import api from './index';

export const analyzeMenu = async (formData) => {
  try {
    const response = await api.post('/analyze-menu', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error analyzing menu:', error);
    throw error;
  }
};

export const getAnalysisHistory = async (skip = 0, limit = 10) => {
  try {
    const response = await api.get(`/analysis-history?skip=${skip}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching analysis history:', error);
    throw error;
  }
};

export const getUsageStats = async () => {
  try {
    const response = await api.get('/usage-stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching usage stats:', error);
    throw error;
  }
};

export const followUpAnalysis = async (data) => {
  try {
    const response = await api.post('/follow-up-analysis', data);
    return response.data;
  } catch (error) {
    console.error('Error with follow-up analysis:', error);
    throw error;
  }
};